import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Article from "@/pages/Article";
import PodcastPage from "@/pages/PodcastPage";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import Cookies from "@/pages/Cookies";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <GoogleAnalytics />
        <Navbar />
        <main className="min-h-[60vh]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/podcast" element={<PodcastPage />} />
            <Route path="/category/:slug" element={<Category />} />
            <Route path="/article/:slug" element={<Article />} />
            <Route path="/podcast" element={<PodcastPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
